import _ from "lodash";
import client from "lib/apolloClient/client";

import {
  getRoutinePostDetailQuery,
  getCourseRoutinePostFeedQuery,
} from "./RoutineQueries";
import {
  routineLikesAndComments,
  courseRoutinePostFragment,
} from "./RoutineFragments";
export const getRoutinePostDetailsFromCache = ({
  postId,
  // translationFilter = {},
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getRoutinePostDetailQuery,
      variables: {
        id: postId,
        // translationFilter,
      },
    });
  } catch (e) {
    console.warn("Error in `getRoutinePostDetailsFromCache`", e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseRoutineFeedFromCache = ({
  courseId,
  filters,
  // translationFilter,
}) => {
  let queryData = {};

  try {
    queryData = client.readQuery({
      query: getCourseRoutinePostFeedQuery,
      variables: {
        id: courseId,
        filters,
        // translationFilter,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const writeCourseRoutineFeedToCache = ({
  courseId,
  filters,
  data,
  translationFilter = {},
}) => {
  client.writeFragment({
    id: `Course:${courseId}`,
    fragment: courseRoutinePostFragment.courseRoutinePost,
    fragmentName: "courseItem",
    variables: {
      filters,
      translationFilter,
    },
    data: data,
  });
};

export const readRoutineLikesAndCommentsFragment = ({ id }) => {
  try {
    return client.readFragment({
      id: `StudentTemplateResponse:${id}`,
      fragment: routineLikesAndComments.likesAndComments,
      fragmentName: "routineLikesAndComments",
    });
  } catch (e) {
    console.warn("Error in `readRoutineLikesAndCommentsFragment`", e);
    return {};
  }
};

export const writeRoutineLikesAndCommentsFragment = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `StudentTemplateResponse:${id}`,
      fragment: routineLikesAndComments.likesAndComments,
      fragmentName: "routineLikesAndComments",
      data,
    });
  } catch (e) {
    console.warn("Error in `writeRoutineLikesAndCommentsFragment`", e);
  }
};
